import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core'

import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { untilDestroyed } from '@app/shared/utils/utils'
import { Store } from '@ngrx/store'
import { RateCardMetaStructureField } from '../../models'
import { ApplicationSettingsActions } from '../../store/application-settings.actions'
import { ApplicationSettingsSelectors } from '../../store/application-settings.selectors'

export interface RateCardFieldsModalConfig {
  saveFields: (fields: any[]) => void
}

@Component({
  selector: 'rate-card-fields-modal',
  templateUrl: './rate-card-fields-modal.component.html',
  styleUrls: ['./rate-card-fields-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RateCardFieldsModalComponent {
  fields: RateCardMetaStructureField[] = []
  editFieldNumber: number

  isLoading$ = this.store$.select(ApplicationSettingsSelectors.selectRateCardMetaStructureLoading)
  rateCardMetaStructureFields$ = this.store$.select(ApplicationSettingsSelectors.selectRateCardMetaStructureFields)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RateCardFieldsModalConfig,
    private store$: Store,
    cdr: ChangeDetectorRef
  ) {
    this.destroy$ = untilDestroyed()

    this.store$.dispatch(ApplicationSettingsActions.getRateCardMetaStructure())

    this.rateCardMetaStructureFields$
      .pipe(this.destroy$())
      .subscribe((fields: RateCardMetaStructureField[]) => ((this.fields = fields || []), cdr.markForCheck()))
  }

  saveFields() {
    this.data.saveFields(this.fields)
  }

  addField() {
    const order = this.fields.reduce(
      (highestOrder, field) => (field.order > highestOrder ? field.order : highestOrder),
      0
    )
    const newField: RateCardMetaStructureField = { name: `Field ${order}`, type: 'TEXT', order: order + 1, uuid: null }
    this.fields = [...this.fields, newField]
  }

  updateField(event, field: RateCardMetaStructureField) {
    event.stopPropagation()
    this.editFieldNumber = field.order
  }

  deleteField(event, field: RateCardMetaStructureField) {
    event.stopPropagation()
    this.fields = this.fields.filter((f) => f.order != field.order)
  }

  saveField(name, field: RateCardMetaStructureField) {
    this.fields = this.fields.map((f) => (f.order === field.order ? { ...f, name } : f))
    this.editFieldNumber = undefined
  }

  private readonly destroy$
  protected readonly MAX_FIELDS = 3
}
